import { __ } from "../../translation";
export const convertKgToGrams = (weightInKg) => {
    if (typeof weightInKg === "string") {
        const parsedWeight = parseFloat(weightInKg);
        if (isNaN(parsedWeight)) {
            console.warn("cannot parse weight of ", weightInKg);
            return NaN;
        }
        weightInKg = parsedWeight;
    }
    const gramsInKg = 1000;
    const weightInGrams = weightInKg * gramsInKg;
    return weightInGrams;
};
export const formattedWeight = (weightInKg) => {
    const weightInGrams = convertKgToGrams(weightInKg);
    return __("productspecification.attribute.formattedWeightInGrams", [weightInGrams]);
};
//# sourceMappingURL=formatWeight.js.map